/**
 * Tabs component init
 * 
 * @since 1.0.0
 * @package crunchy
 */
(function($) {
	$(document).ready(function() {

		// check if jQuery UI tabs were loaded
		if ( ! ( 'tabs' in $.fn ) ) {
			return;
		}


		// init tabs after images have loaded
		var tabs = $( '.tabs' );
		tabs.imagesLoaded( initTabs );


		/**
		 * Initialize tabs
		 */
		function initTabs() {

			// init slider if passed sanity check
			if ( ( 'flickity' in $.fn ) && ( ! $( '.disable-tab-slider' ).length ) ) {

				$( '.tabs .slides' ).flickity({
					cellAlign		: 'left',
					groupCells		: true,
					contain			: true,
					arrowShape		: {
						x0: 10,
						x1: 60, y1: 50,
						x2: 75, y2: 35,
						x3: 40
					}
				});
			}


			tabs.tabs({
				heightStyle : setHeightStyle(),
			});
		}


		/**
		 * Figure out what height style we want
		 */
		function setHeightStyle() {
			return $( window ).width() >= 1024 ? 'auto' : 'content';
		}

	}); // document.ready
})(jQuery);